export default {
  BANK_ACCOUNT: "bank_account",
  CURRENT_LIVING_CONDITION: "current_living_condition",
  CUSTOMER: "customer",
  DAMAGE: "damage",
  INCOME_BENEFIT: "income_benefit",
  INCOME_COMPANY: "income_company",
  INCOME_EMPLOYMENT: "income_employment",
  INCOME_OTHER: "income_other",
  INCOME_RETIREMENT: "income_retirement",
  MORTGAGE: "mortgage",
  OBLIGATION: "obligation",
  POLICY: "policy",
  POSSESSION: "possession",
  RETIREMENT: "retirement",
  TASK: "task",
};
